import { useNavigate, useSearch } from '@tanstack/react-router';

import { Tabs } from '../../../cdl/Tabs/Tabs';
import { VesselStatus } from '../types/VesselStatus';
import { useVesselOverviewFilters } from '../useVesselOverviewFilters';
import { useVesselPaginationTotals } from '../useVesselPaginationTotals';

export const VesselStatusTabs = () => {
    const search = useSearch({ from: '/_app/vessels' });
    const navigate = useNavigate({ from: '/vessels' });
    const filters = useVesselOverviewFilters();
    const { data: totals } = useVesselPaginationTotals(filters);

    return (
        <Tabs
            selectedContext={search.tab}
            totals={{ active: totals?.active, inactive: totals?.inactive }}
            onSelect={(tab: VesselStatus) => navigate({ search: (previous) => ({ ...previous, tab, page: 0 }) })}
        />
    );
};
